import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Form, Grid, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import DateHelper from '../../app/helpers/dateHelper';
import LoadingComponent from '../../app/layout/LoadingComponent';
import { useStore } from '../../app/stores/store';

// #region Styling
const StyledTextArea = styled(Form.TextArea)`
        textarea{
            resize:none !important;
        }
`;

const StyledContainer = styled.div`
        padding: ${props => props.theme.padding.featureContainer};
`;

const StyledCardContainer = styled.div`
        padding: 2em;
        background-color: #fff;
        border-radius: 16px;
`;

// #endregion

const dateHelper = new DateHelper();

const LeaveRequestDetails = () => {
    const { id } = useParams<{ id: string }>();
    const { leaveRequestStore } = useStore();
    const { leaveRequest, loadLeaveRequest, isLeaveRequestDetailsLoading } = leaveRequestStore;

    useEffect(() => {
        loadLeaveRequest(id);
    }, [loadLeaveRequest, id]);

    if (isLeaveRequestDetailsLoading) return <LoadingComponent content='Loading Leave Request Details...' />

    return (
        <StyledContainer>
            <StyledCardContainer>
                <Grid divided='vertically'>
                    <Grid.Row>
                        <Grid.Column width={3}>
                            <Header >Leave Request Details</Header>
                        </Grid.Column>
                        <Grid.Column width={10} style={{ marginTop: '2em' }}>
                            <Form>
                                <Form.Group>
                                    <Form.Input value={leaveRequest?.user.name} readOnly name='employee' label='Employee' width={8} />
                                    <Form.Input value={leaveRequest?.leaveType.type} readOnly name='leaveType' label='Leave Type' width={8} />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Input type='text' value={leaveRequest?.from != undefined ? dateHelper.formatShortDate(leaveRequest?.from.toString()) : ""} readOnly name='from' label='From' width={8} />
                                    <Form.Input type='text' value={leaveRequest?.to != undefined ? dateHelper.formatShortDate(leaveRequest?.to.toString()) : ""} readOnly name='to' label='To' width={8} />
                                </Form.Group>
                                <Form.Group>
                                    <StyledTextArea rows={3} value={leaveRequest?.reason} readOnly name='reason' label='Reason' width={16} />
                                </Form.Group>
                            </Form>
                        </Grid.Column>
                        <Grid.Column width={3}>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Button as={Link} color='grey' basic floated='right' to='/requests/leave-requests'>Cancel</Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </StyledCardContainer>
        </StyledContainer>
    );
}

export default observer(LeaveRequestDetails);